<template>
  <van-popup v-model="showNotice" position="bottom" class="backRect" @closed="onClosed">
    <div class="titleRect">
      <van-row gutter="20">
        <van-col span="20" class="title">出行目的地</van-col>
        <van-col span="4" class="rigth"> <i class="iconfont iconwancheng1" @click="onBack" /> </van-col>
      </van-row>
    </div>
    <div class="selectRect">
      <van-skeleton title :row="20" :loading="loading">
        <van-index-bar>
          <template v-for="key in indexList">
            <van-index-anchor v-if="key.list.length>0" :key="key.key" :index="key.key" />
            <van-cell v-for="(item,index) in key.list" :key="index" :title="item.cName+' '+item.eName" @click="onSelect(item)" />
          </template>
        </van-index-bar>
      </van-skeleton>
    </div>
    <div class="selectTag">
      <van-tag v-for="(item,index) in selectList" :key="index" :color="GetColorMainBack()" closeable @close="onDeleteSelect(item)">{{ item }}</van-tag>
    </div>
  </van-popup>

</template>
<script>
import request from '@/utils/request'
import { Button, Popup, IndexBar, IndexAnchor, Tag, Skeleton } from 'vant'
import { getUserBase } from '@/utils/base'
import { ShowMoneySpan, MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [Popup.name]: Popup,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Tag.name]: Tag,
    [Skeleton.name]: Skeleton
  },
  props: {
    // eslint-disable-next-line
    value:undefined,
    // eslint-disable-next-line
    defaultValue:undefined
  },
  data() {
    return {
      loading: true,
      showNotice: false,
      cashCode: undefined,
      indexList: [

      ],
      data: {
        destinations: []
      },
      selectList: []
    }
  },
  watch: {
    value(newValue) {
      this.selectList = []
      if (newValue) {
        this.showNotice = true
        this.cashCode = newValue
        this.init()
      } else {
        this.showNotice = false
        this.cashCode = undefined
      }
    },
    defaultValue(newValue) {
      console.log(newValue)
      this.selectList = []
      if (newValue) {
        this.selectList = newValue.split(',')
      }
      console.log('this.selectList', this.selectList)
    }
  },
  created() {

  },
  methods: {
    ShowMoneySpan,
    MyNotify,
    getUserBase,
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    init() {
      this.loading = true
      request({
        url: '/Insurance/GetProductDestination',
        method: 'post',
        params: { id: this.cashCode }
      }).then(response => {
        this.loading = false
        if (!response.success) {
          return
        }
        this.data = response.data
        this.indexList = []
        for (var i = 0; i < 26; i++) {
          var key = String.fromCharCode(65 + i)
          this.indexList.push({
            key: key,
            list: this.data.destinations.filter(el => el.initial === key)
          })
        }
        console.log('list', this.indexList)
      })
    },
    onClosed() {
      this.$emit('input', undefined)
    },
    onSelect(item) {
      if (this.data.chooseOne) {
        this.selectList = []
        this.selectList.push(item)
      } else {
        var i = this.selectList.findIndex(el => el === item.cName)
        if (i >= 0) {
          this.onDeleteSelect(item)
        } else {
          if (this.selectList.length >= 5) {
            MyNotify('error', '最多只能选择5个目的地')
            return
          }
          this.selectList.push(item.cName)
        }
      }
    },
    onDeleteSelect(item) {
      this.selectList.splice(this.selectList.findIndex(el => el === item.cName), 1)
    },
    onBack() {
      console.log('onSelect', this.selectList.join(','))
      this.$emit('onSelect', this.selectList.join(','))
      this.showNotice = false
    }
  }
}
</script>
<style scoped>
.backRect{
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    overflow: hidden;
}
.titleRect{
  line-height: 3em;
  font-size: 1.1em;
  padding: 0 1em;
}
.titleRect .title{
  font-weight: 700;
}
.selectRect{
    max-height: calc(100vh - 7em);
    overflow-y: scroll;
}
.selectTag{
  border-top: 1px solid #f5f5f5;
  padding: 0.5em 1em;
}
.selectTag span{
  margin-right: 0.5em;
  margin-bottom: 0.5em;
}

</style>
